import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { CustomizableComponent } from '../../FormWidgets/CustomizableComponent';
import { makeAHUInfoObject } from '../../Utils/utils.js';
import { GlobalInfoContent, ZoneInfoContent } from '../Info.js';
import { hasNutritionTankInfo } from '../NutritionTankInfo';

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(3)
  },
  heading: {
    display: 'inline-block',
    margin: theme.spacing(0, 0, 1),
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold
  }
}));

export default function ZoneOverview({ controller }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const snapshot = useSnapshot(controller);
  const zones = Object.values(controller.zones ?? {});
  const globalAhuInfos = makeAHUInfoObject(snapshot, snapshot, false).ahui ?? [];
  const hasGlobalInfo =
    globalAhuInfos.some((unit) => unit.show_this_unit === 1) ||
    hasNutritionTankInfo(snapshot, snapshot);

  return (
    <>
      {hasGlobalInfo && (
        <CustomizableComponent
          controller={controller}
          parent={controller}
          id="global"
          ext_id="edit_global"
          visibilityIconPosition="heading-end"
          zIndex="-2"
        >
          <section className={classes.section}>
            <h1 className={classes.heading} data-customization-heading>
              {t('global')}
            </h1>
            <GlobalInfoContent controller={controller} />
          </section>
        </CustomizableComponent>
      )}

      {zones.map((zone) => (
        <CustomizableComponent
          controller={controller}
          parent={controller}
          id={`zoneoverview_${zone.id}`}
          ext_id={`edit_zoneoverview_${zone.id}`}
          key={`zone-overview-${zone.id}`}
          visibilityIconPosition="heading-end"
          zIndex="-2"
        >
          <section className={classes.section}>
            <h1 className={classes.heading} data-customization-heading>
              {zone.name}
            </h1>
            <ZoneInfoContent
              controller={controller}
              customizationScope={`overview:${zone.id}`}
              parent={zone}
            />
          </section>
        </CustomizableComponent>
      ))}
    </>
  );
}
